import React from 'react';
import markerStyles from './marker.module.scss';

const UserPoint = () => (
  <div className={markerStyles.user_point} />
);

export default UserPoint;
